import handleErr from './handle-error'
import { getPlanName } from './helpers'
import subscriptionsPlans from './subscriptions-plan'

const getPlanPrice = ({ activeAgreement }) => {
  try {
    return (
      subscriptionsPlans.find((p) => {
        return (
          p?.name.toLowerCase() ===
          getPlanName({ agreement: activeAgreement })?.toLowerCase().replaceAll('+', '_')
        )
      })?.price || 1
    )
  } catch (err) {
    handleErr({ err })
    return 1
  }
}

export default getPlanPrice
